import { render } from "./AppInfoGtm.vue?vue&type=template&id=641efc26"
import script from "./AppInfoGtm.vue?vue&type=script&lang=ts"
export * from "./AppInfoGtm.vue?vue&type=script&lang=ts"
script.render = render

export default script